import { createStyles } from '../../../../../../styles/helpers'

export default createStyles({
  sectionDescription: {
    marginBottom: '15px'
  }
})
